@if (arbetsorder !== undefined) {
<div>
    <div class="arbetsorder-list-row">
        @if (presentationRules.ttVisible) {
        <div class="table-cell table-cell-produkttyp">
            <label class="min-padding col-form-label" translate="PLANERA_ARBETSORDER_HEADER_TALLTIMMER"></label>
        </div>
        }
        @if (presentationRules.gtVisible) {
        <div class="table-cell table-cell-produkttyp">
            <label class="min-padding col-form-label" translate="PLANERA_ARBETSORDER_HEADER_GRANTIMMER"></label>
        </div>
        }
        @if (presentationRules.kttVisible) {
        <div class="table-cell table-cell-produkttyp">
            <label class="min-padding col-form-label" translate="PLANERA_ARBETSORDER_HEADER_KLENTIMMER_TALL"></label>
        </div>
        }
        @if (presentationRules.kgtVisible) {
        <div class="table-cell table-cell-produkttyp">
            <label class="min-padding col-form-label" translate="PLANERA_ARBETSORDER_HEADER_KLENTIMMER_GRAN"></label>
        </div>
        }
        @if (presentationRules.bmavVisible) {
        <div class="table-cell table-cell-produkttyp">
            <label class="min-padding col-form-label" translate="PLANERA_ARBETSORDER_HEADER_B-MAV"></label>
        </div>
        }
        @if (presentationRules.lmavVisible) {
        <div class="table-cell table-cell-produkttyp">
            <label class="min-padding col-form-label" translate="PLANERA_ARBETSORDER_HEADER_L-MAV"></label>
        </div>
        }
        @if (presentationRules.tVisible) {
        <div class="table-cell table-cell-produkttyp">
            <label class="min-padding col-form-label" translate="PLANERA_ARBETSORDER_HEADER_TALL"></label>
        </div>
        }
        @if (presentationRules.gVisible) {
        <div class="table-cell table-cell-produkttyp">
            <label class="min-padding col-form-label" translate="PLANERA_ARBETSORDER_HEADER_GRAN"></label>
        </div>
        }
        @if (presentationRules.lVisible) {
        <div class="table-cell table-cell-produkttyp">
            <label class="min-padding col-form-label" translate="PLANERA_ARBETSORDER_HEADER_LOV"></label>
        </div>
        }
        @if (presentationRules.cVisible) {
        <div class="table-cell table-cell-produkttyp">
            <label class="min-padding col-form-label" translate="PLANERA_ARBETSORDER_HEADER_CONTORTA"></label>
        </div>
        }
        @if (presentationRules.noGrotData) {
        <div class="table-cell table-cell-produkttyp">
            <label class="min-padding col-form-label">&nbsp;</label>
        </div>
        }
        @if (presentationRules.noGrotData) {
        <div class="table-cell table-cell-produkttyp">
            <label class="min-padding col-form-label">&nbsp;</label>
        </div>
        }
        @if (presentationRules.noGrotData) {
        <div class="table-cell table-cell-produkttyp">
            <label class="min-padding col-form-label">&nbsp;</label>
        </div>
        }
        @if (presentationRules.noGrotData) {
        <div class="table-cell table-cell-produkttyp">
            <label class="min-padding col-form-label">&nbsp;</label>
        </div>
        }
        <div class="table-cell table-cell-produkttyp"></div>
        <div class="table-cell table-cell-produkttyp">
            @if (!arbetsorder.isLeveransvirke && !arbetsorder.isExternArbetsorder) {
            <label
                class="min-padding col-form-label" translate="PLANERA_ARBETSORDER_HEADER_TILLGANGLIGHET_SKOG"></label>
            }
        </div>
        <div class="table-cell table-cell-produkttyp">
            @if (!arbetsorder.isExternArbetsorder) {
            <label class="min-padding col-form-label"
                translate="PLANERA_ARBETSORDER_HEADER_BILVAG"></label>
            }
        </div>
        <div class="table-cell table-cell-produkttyp">
            @if (isGrot()) {
            <label class="min-padding col-form-label"
                translate="PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_SKORDAD"></label>
            }
        </div>
    </div>
    <div class="arbetsorder-list-row">
        @if (presentationRules.ttVisible) {
        <div class="table-cell table-cell-produkttyp">{{ arbetsorder.tallTimmer }}
        </div>
        }
        @if (presentationRules.gtVisible) {
        <div class="table-cell table-cell-produkttyp">{{ arbetsorder.granTimmer }}
        </div>
        }
        @if (presentationRules.kttVisible) {
        <div class="table-cell table-cell-produkttyp">{{ arbetsorder.klentimmerTall
            }}</div>
        }
        @if (presentationRules.kgtVisible) {
        <div class="table-cell table-cell-produkttyp">{{ arbetsorder.klentimmerGran
            }}</div>
        }
        @if (presentationRules.bmavVisible) {
        <div class="table-cell table-cell-produkttyp">{{ arbetsorder.barrmassaved
            }}</div>
        }
        @if (presentationRules.lmavVisible) {
        <div class="table-cell table-cell-produkttyp">{{ arbetsorder.lovmassaved
            }}</div>
        }
        @if (presentationRules.tVisible) {
        <div class="table-cell table-cell-produkttyp">{{
            formatFordelning(arbetsorder.andelTall) }}</div>
        }
        @if (presentationRules.gVisible) {
        <div class="table-cell table-cell-produkttyp">{{
            formatFordelning(arbetsorder.andelGran) }}</div>
        }
        @if (presentationRules.lVisible) {
        <div class="table-cell table-cell-produkttyp">{{
            formatFordelning(arbetsorder.andelLov) }}</div>
        }
        @if (presentationRules.cVisible) {
        <div class="table-cell table-cell-produkttyp">{{
            formatFordelning(arbetsorder.andelContorta) }}</div>
        }
        @if (presentationRules.noGrotData) {
        <div>
            <div class="table-cell table-cell-produkttyp"></div>
            <div class="table-cell table-cell-produkttyp"></div>
            <div class="table-cell table-cell-produkttyp"></div>
            <div class="table-cell table-cell-produkttyp"></div>
        </div>
        }
        <div class="table-cell table-cell-produkttyp"></div>
        @if (!arbetsorder.isExternArbetsorder) {
        <div class="table-cell table-cell-produkttyp">{{
            arbetsorder.tillganglighetMark || '' }}</div>
        }
        @if (!arbetsorder.isExternArbetsorder) {
        <div class="table-cell table-cell-barighet-vag">{{
            arbetsorder.tillganglighetVag || '' }}</div>
        }
        @if (isGrot()) {
        <div class="table-cell table-cell-period ps-2">{{
            ($safeNavigationMigration(arbetsorder.tidpunkter?.skordningAvslutadDatum) | date:'yyyy-MM-dd') || '' }}</div>
        }
        <div class="table-cell float-end">
            @if (isSkordarmatning()) {
            <rask-arbetsorder-warning-pill>
                ESM
            </rask-arbetsorder-warning-pill>
            }
            @if (hasExtraordinarHandelse()) {
            <rask-arbetsorder-warning-pill class="extraordinar-handelse">
                EOH
            </rask-arbetsorder-warning-pill>
            }
            @if (arbetsorder.varningProduktionsplan) {
            <rask-arbetsorder-warning-pill>
                {{arbetsorder.varningProduktionsplanTradslag}}
            </rask-arbetsorder-warning-pill>
            }
        </div>
    </div>
    <div class="arbetsorder-list-footer">
        <div class="table-cell table-cell-period" aid="ao-period-datum">{{ getArbetsorderPeriod(arbetsorder) }}</div>
        <div class="table-cell table-cell-icons">
            <rask-arbetsorder-status-ikoner
                [arbetsorderStatusIcons]="arbetsorderStatusIcons"
                [arbetsorderValsSynkroniseringstatus]="$safeNavigationMigration(arbetsorder?.arbetsorderValsSynkroniseringstatus)"
                [restriktionEjKlar]="$safeNavigationMigration(arbetsorder?.restriktionEjKlar)"
                [restriktionHanterad]="$safeNavigationMigration(arbetsorder?.restriktionHanterad)"
                [showSpinner]="showSpinner$"
                [showViol3Spinner]="showViol3Spinner$"
                [virkeskopIcon]="virkeskopIcon$"
                [viol3Icon]="viol3Icon$">
            </rask-arbetsorder-status-ikoner>
        </div>
    </div>
</div>
}